/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(9);
module.exports = __webpack_require__(10);


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ContactForm(id) {
  this.$el = $(id);
  if (this.$el.length < 1) {
    return;
  }

  var prefix = id.substr(1);
  this.$el.on('submit', this.onSubmit.bind(this));
  this.$content = this.$el.find('.' + prefix + '-content');
  this.$confirmation = this.$el.find('.' + prefix + '-confirmation');
  this.$error = this.$el.find('.' + prefix + '-error');
}

ContactForm.prototype.onSubmit = function (evt) {
  function blur() {
    $(evt.target).find('[type="submit"]').blur();
  }

  $.post(this.$el.attr('action'), this.$el.serialize()).then(function () {
    blur();
    this.$content.hide();
    this.$confirmation.show();
  }.bind(this), function (evt) {
    blur();
    this.$error.show();
  }.bind(this));

  return false;
};

new ContactForm('#analysis-form');
new ContactForm('#analysis-content-form');
new ContactForm('#contact-form');

jQuery(function ($) {
  $(document).ready(function () {
    if (app.config.isBackend) return;

    if (window.matchMedia && window.matchMedia('(min-width: 992px)').matches) {
      $('.nav').sticky({
        topSpacing: 45,
        zIndex: 100
      });
    }
  });
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// Scripts/application.js